import * as React from 'react'

const SvgLevelIcon = (props) => (
  <svg
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 13.3337L22.5 7.50033L12 1.66699L1.5 7.50033L12 13.3337ZM12 13.3337L19.1856 9.34163C19.8187 10.938 20.1667 12.6785 20.1667 14.5003C20.1667 15.3185 20.0965 16.1203 19.9618 16.9C16.9167 17.1961 14.1572 18.4677 12 20.3985C9.84279 18.4677 7.08333 17.1961 4.03822 16.9C3.90353 16.1202 3.83333 15.3184 3.83333 14.5002C3.83333 12.6784 4.18128 10.938 4.81435 9.34161L12 13.3337ZM7.33333 20.3336V11.5837L12 8.99107"
      stroke="url(#paint0_linear_1081_3527)"
      strokeWidth="2.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1081_3527"
        x1="3.32609"
        y1="2.74974"
        x2="14.7218"
        y2="17.7092"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.135417" stopColor="#FF692E" />
        <stop offset="1" stopColor="#FF692E" />
      </linearGradient>
    </defs>
  </svg>
)

export default SvgLevelIcon
